/* styles */
import useStyles from './useStyles'
import { Checkbox, IconButton, Tooltip } from '@mui/material'
import ModalMenuItem from '../../Modals/ModalMenu/ModalMenu'
import { getTraducTypeUser } from '../../../../../utils/UserTools'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'

function TableItem ({ item, setLoading }) {
  const classes = useStyles()

  const getIconStatus = (status) => {
    if (status) {
      switch (status.userStatusCode) {
        case 'ACTIVE':
          return (
            <Tooltip title="Activo">
              <IconButton>
                <GppGoodOutlinedIcon className={classes.hoverButton} />
              </IconButton>
            </Tooltip>
          )
        case 'WAITING_VALIDATION':
          return (
            <Tooltip title="Esperando validación">
              <IconButton>
                <HelpOutlineOutlinedIcon className={classes.hoverButton} />
              </IconButton>
            </Tooltip>
          )
        case 'BLOCKED':
          return (
            <Tooltip title="Bloqueado">
              <IconButton>
                <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
              </IconButton>
            </Tooltip>
          )
        case 'INACTIVE':
          return (
            <Tooltip title="Inactivo">
              <IconButton>
                <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
              </IconButton>
            </Tooltip>
          )
        // no funciona
        case 'SUSPENDED':
          return (
            <Tooltip title="Suspendido">
              <IconButton>
                <GppMaybeIcon className={classes.hoverButtonDelete} />
              </IconButton>
            </Tooltip>
          )

        default:
          return (
            <Tooltip title={status.userStatusName}>
              <IconButton>
                <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
              </IconButton>
            </Tooltip>
          )
      }
    }
  }

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemStatus}>
          {getIconStatus(item.status) || '- -'}
        </td>
        <td className={classes.itemName}>
          {item.organization?.organizationName || '- -'}
        </td>
        <td className={classes.itemLegalName}>
          {item.organization?.organizationLegalName || '- -'}
        </td>
        <td className={classes.itemCuit}>
          {item.organization?.organizationCuit || '- -'}
        </td>
        <td className={classes.itemType}>
          {getTraducTypeUser(item.type?.organizationUserTypeCode) || '- -'}
        </td>

        <td className={classes.itemKebab}>
          <ModalMenuItem item={item} setLoading={setLoading} />
        </td>
      </tr>
    </>
  )
}

export default TableItem
